import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    downloadIcon: {
      width: theme.spacing(2),
      height: theme.spacing(2),
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
    },
    downloadButton: {
      textTransform: 'none',
      color: theme.palette.primary.main,
    },
  })
);
